<template>
  <div class='card'>
    <div class='card-body'>
      <div class='row'>
        <h5 class='float-start card-title'>Documents</h5>
      </div>
      <div class='row'>
        <div class='container'>
          <div class='row'>
            <div class='col-md-3 col-sm-3'>
              <label>National ID</label> <br>
              <div v-if='partnerDocument.national_id == null'>
                <div class='image-upload-wrap'>
                  <input class='file-upload-input' type='file' @change='onNationalIdFileChange'
                         accept='image/*' />
                  <div class='drag-text'>
                    <h3>Drag and drop a file or select add Image</h3>
                  </div>
                </div>
              </div>
              <div v-else>
                <img :src='partnerDocument.national_id' id='showOwnerNationalId'
                     @click='showPictureModal($event,"Show National Id")' data-bs-toggle='modal'
                     data-bs-target='#imageModalShow'
                     class='img-fluid img-thumbnail image-style' alt=''>
                <p>
                  <button type='button' class='btn btn-link' @click='removePicture("nid")'>Remove NID</button>
                </p>
              </div>
            </div>
            <div class='col-md-3 col-sm-3'>
              <label>Driver's License</label>
              <div v-if='partnerDocument.driving_license == null'>
                <div class='image-upload-wrap'>
                  <input class='file-upload-input' @change='onDrivingLicenseFileChange' type='file'
                         accept='image/*' />
                  <div class='drag-text'>
                    <h3>Drag and drop a file or select add Image</h3>
                  </div>
                </div>
              </div>
              <div v-else>
                <img :src='partnerDocument.driving_license' @click='showPictureModal($event,"Show Driver License")'
                     data-bs-toggle='modal'
                     data-bs-target='#imageModalShow'
                     class='img-fluid img-thumbnail image-style' alt=''>
                <p>
                  <button type='button' class='btn btn-link' @click='removePicture("license")'>Remove License</button>
                </p>
              </div>

            </div>
            <div class='col-md-3 col-sm-3'>
              <label>Tax Token</label>
              <div v-if='partnerDocument.tax_token == null'>
                <div class='image-upload-wrap'>
                  <input class='file-upload-input' @change='onTaxTokenChange' type='file' accept='image/*' />
                  <div class='drag-text'>
                    <h3>Drag and drop a file or select add Image</h3>
                  </div>
                </div>
              </div>
              <div v-else>
                <img :src='partnerDocument.tax_token' @click='showPictureModal($event,"Show Tax Token")'
                     data-bs-toggle='modal'
                     data-bs-target='#imageModalShow'
                     class='img-fluid img-thumbnail image-style' alt=''>
                <p>
                  <button type='button' class='btn btn-link' @click='removePicture("tax token")'>Remove Token
                  </button>
                </p>
              </div>
            </div>
            <div class='col-md-3 col-sm-3'>
              <label>Fitness Certificate</label> <br>
              <div v-if='partnerDocument.fitness_certificate == null'>
                <div class='image-upload-wrap'>
                  <input class='file-upload-input' type='file' @change='onFitnessCertificateChange'
                         accept='image/*' />
                  <div class='drag-text'>
                    <h3>Drag and drop a file or select add Image</h3>
                  </div>
                </div>
              </div>
              <div v-else>
                <img :src='partnerDocument.fitness_certificate' id='fitness_certificate'
                     @click='showPictureModal($event,"Show Fitness Certificate")' data-bs-toggle='modal'
                     data-bs-target='#imageModalShow'
                     class='img-fluid img-thumbnail image-style' alt=''>
                <p>
                  <button type='button' class='btn btn-link' @click='removePicture("fitness certificate")'>Remove certificate
                  </button>
                </p>
              </div>
            </div>
            <div class='col-md-3'>
              <label>Registration Certificate</label>
              <div v-if='partnerDocument.registration_number == null'>
                <div class='image-upload-wrap'>
                  <input class='file-upload-input' @change='onRegistrationFileChange' type='file'
                         accept='image/*' />
                  <div class='drag-text'>
                    <h3>Drag and drop a file or select add Image</h3>
                  </div>
                </div>
              </div>
              <div v-else>
                <img :src='partnerDocument.registration_number'
                     @click='showPictureModal($event,"Show Registration Image")' data-bs-toggle='modal'
                     data-bs-target='#imageModalShow'
                     class='img-fluid img-thumbnail image-style' alt=''>
                <p>
                  <button type='button' class='btn btn-link' @click='removePicture("registration number")'>Remove
                    Registration
                  </button>
                </p>
              </div>

            </div>
            <div class='col-md-3 col-sm-3'>
              <label>Vehicle Picture</label>
              <div v-if='partnerDocument.car_image == null'>
                <div class='image-upload-wrap'>
                  <input class='file-upload-input' @change='onCarImageChange' type='file' accept='image/*' />
                  <div class='drag-text'>
                    <h3>Drag and drop a file or select add Image</h3>
                  </div>
                </div>
              </div>
              <div v-else>
                <img :src='partnerDocument.car_image' @click='showPictureModal($event,"Show Vehicle Picture")'
                     data-bs-toggle='modal'
                     data-bs-target='#imageModalShow'
                     class='img-fluid img-thumbnail image-style' alt=''>
                <p>
                  <button type='button' class='btn btn-link' @click='removePicture("car image")'>Remove car  picture
                  </button>
                </p>
              </div>
            </div>
            <div class='col-md-3 col-sm-3'>
              <label>Driver Picture</label>
              <div v-if='partnerDocument.profile_picture == null'>
                <div class='image-upload-wrap'>
                  <input class='file-upload-input' @change='onProfilePictureChange' type='file' accept='image/*' />
                  <div class='drag-text'>
                    <h3>Drag and drop a file or select add Image</h3>
                  </div>
                </div>
              </div>
              <div v-else>
                <img :src='partnerDocument.profile_picture' @click='showPictureModal($event,"Show Profile Picture")'
                     data-bs-toggle='modal'
                     data-bs-target='#imageModalShow'
                     class='img-fluid img-thumbnail image-style' alt=''>
                <p>
                  <button type='button' class='btn btn-link' @click='removePicture("profile picture")'>Remove
                    picture
                  </button>
                </p>
              </div>
            </div>
            <div class='col-md-3 col-sm-3'>
              <label>Vaccine Certificate</label>
              <div v-if='partnerDocument.vaccine_certificate == null'>
                <div class='image-upload-wrap'>
                  <input class='file-upload-input' @change='onVaccineCertificateChange' type='file' accept='image/*' />
                  <div class='drag-text'>
                    <h3>Drag and drop a file or select add Image</h3>
                  </div>
                </div>
              </div>
              <div v-else>
                <img :src='partnerDocument.vaccine_certificate'
                     @click='showPictureModal($event,"Show Vaccine Certificate")' data-bs-toggle='modal'
                     data-bs-target='#imageModalShow'
                     class='img-fluid img-thumbnail image-style' alt=''>
                <p>
                  <button type='button' class='btn btn-link' @click='removePicture("vaccine certificate")'>Remove
                     picture
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class='modal fade' id='imageModalShow' tabindex='-1' aria-labelledby='exampleModalLabel' aria-hidden='true'>
    <div class='modal-dialog'>
      <div class='modal-content'>
        <div class='modal-header'>
          <h5 class='modal-title' id='exampleModalLabel'>{{ imageTitle }}</h5>
          <button type='button' class='btn-close' data-bs-dismiss='modal' aria-label='Close'></button>
        </div>
        <div class='modal-body'>
          <img :src='showImage' class='rounded mx-auto d-block' alt='...' style='height: 257px; width: 476px;'>
        </div>
        <div class='modal-footer'>
          <button type='button' class='btn btn-secondary' data-bs-dismiss='modal'>Close</button>
        </div>
      </div>
    </div>
  </div>

</template>

<!--<script class="jsbin" src="https://ajax.googleapis.com/ajax/libs/jquery/1/jquery.min.js"></script>-->
<script>
import http from '../../config/axios';


export default {
  name: 'Document',
  props: ['alert', 'swal'],

  data() {
    return {
      partnerDocument: [],
      documentObject: {
        national_id: null,
        tax_token: null,
        driving_license: null,
        fitness_certificate: null,
        registration_number: null,
        car_image: null,
        profile_picture: null,
        vaccine_certificate: null
      },
      showImage: '',
      imageTitle: ''
    };
  },
  mounted() {
    this.getVehicleInformation();
  },
  methods: {
    getVehicleInformation() {
      http.get('v3/partners/' + `${this.$route.params.id}` + '/documents')
        .then(response => {
          this.partnerDocument = response.data.data;
        })
        .catch(error => {
          this.errorMessage = error.message;
          console.error('There was an error!', error);
        });
    },
    onNationalIdFileChange(event) {
      this.documentObject.national_id = event.target.files[0];
      const formData = new FormData();
      formData.append('national_id', this.documentObject.national_id);
      this.uploadPartnerDocument(formData);
    },
    onDrivingLicenseFileChange(event) {
      this.documentObject.driving_license = event.target.files[0];
      const formData = new FormData();
      formData.append('driving_license', this.documentObject.driving_license);
      this.uploadPartnerDocument(formData);

    },
    onTaxTokenChange(event) {
      this.documentObject.tax_token = event.target.files[0];
      const formData = new FormData();
      formData.append('tax_token', this.documentObject.tax_token);
      this.uploadPartnerDocument(formData);

    },
    onFitnessCertificateChange(event) {
      this.documentObject.fitness_certificate = event.target.files[0];
      const formData = new FormData();
      formData.append('fitness_certificate', this.documentObject.fitness_certificate);
      this.uploadPartnerDocument(formData);

    },
    onRegistrationFileChange(event) {
      this.documentObject.registration_number = event.target.files[0];
      const formData = new FormData();
      formData.append('registration_number', this.documentObject.registration_number);
      this.uploadPartnerDocument(formData);
    },
    onProfilePictureChange(event) {
      this.documentObject.profile_picture = event.target.files[0];
      const formData = new FormData();
      formData.append('profile_picture', this.documentObject.profile_picture);
      this.uploadPartnerDocument(formData);
    },
    onVaccineCertificateChange(event) {
      this.documentObject.vaccine_certificate = event.target.files[0];
      const formData = new FormData();
      formData.append('vaccine_certificate', this.documentObject.vaccine_certificate);
      this.uploadPartnerDocument(formData);
    },

    uploadPartnerDocument(formData) {
      http.post('/v3/partners/' + `${this.$route.params.id}` + '/documents', formData)
        .then(
          response => {
            if (response.status === 200) {
              //  alert('Image upload successfully.')
              this.getVehicleInformation();
              this.$swal('Submit!', 'Image upload successfully', 'success');

            }
          }
        )
        .catch(error => {
          this.errorMessage = error.message;
          console.error('There was an error!', error);
        });
    },
    removePicture(value) {
      if (value === 'nid') {
        this.partnerDocument.national_id = null;
      }

      if (value === 'license') {
        this.partnerDocument.driving_license = null;
      }

      if (value === 'tax token') {
        this.partnerDocument.tax_token = null;
      }

      if (value === 'fitness certificate') {
        this.partnerDocument.fitness_certificate = null;
      }
      if (value === 'registration number') {
        this.partnerDocument.registration_number = null;
      }
      if (value === 'car image') {
        this.partnerDocument.car_image = null;
      }
      if (value === 'profile picture') {
        this.partnerDocument.profile_picture = null;
      }
      if (value === 'vaccine certificate') {
        this.partnerDocument.vaccine_certificate = null;
      }
    },
    showPictureModal(e, message) {
      this.showImage = e.target.src;
      this.imageTitle = message;
    }
  }

};
</script>

<style scoped>

.file-upload {
  background-color: #ffffff;
  /*width: 100%;*/
  height: 30px;

}

.file-upload-btn {
  width: 100%;
  margin: 0;
  color: #fff;
  background: #1FB264;
  border: none;
  padding: 10px;
  border-radius: 4px;
  border-bottom: 4px solid #c2c7c4;
  transition: all .2s ease;
  outline: none;
  text-transform: uppercase;
  font-weight: 12;
}

.file-upload-btn:hover {
  background: #1AA059;
  color: #ffffff;
  transition: all .2s ease;
  cursor: pointer;
}

.file-upload-btn:active {
  border: 0;
  transition: all .2s ease;
}

.file-upload-content {
  display: none;
  text-align: center;
}

.file-upload-input {
  position: absolute;
  width: 100%;
  height: 100%;
  outline: none;
  opacity: 0;
  cursor: pointer;
}

.image-upload-wrap {
  border: 4px dashed #1FB264;
  position: relative;
  margin-bottom: 10px;
  height: 100px;
  width: 100px;
}

.image-dropping,
.image-upload-wrap:hover {
  background-color: #1FB264;
}

.image-title-wrap {
  padding: 0 15px 15px 15px;
  color: #222;
}

.drag-text {
  text-align: center;
  margin-top: -29px;
}

.drag-text h3 {
  font-weight: 100;
  text-transform: uppercase;
  color: #15824B;
  padding: 60px 0;
  font-size: 5px;
}

.file-upload-image {
  max-height: 200px;
  max-width: 200px;
  margin: auto;
  padding: 20px;
}

.remove-image {
  width: 200px;
  margin: 0;
  color: #fff;
  background: #cd4535;
  border: none;
  padding: 10px;
  border-radius: 4px;
  border-bottom: 4px solid #b02818;
  transition: all .2s ease;
  outline: none;
  text-transform: uppercase;
  font-weight: 700;
}

.remove-image:hover {
  background: #c13b2a;
  color: #ffffff;
  transition: all .2s ease;
  cursor: pointer;
}

.remove-image:active {
  border: 0;
  transition: all .2s ease;
}

.image-style {
  height: 100px;
  width: 100px;
}

label {
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  font-family: 'Montserrat';
}

.btn btn-link {
  font-size: 14px;
  margin: auto;
}

</style>